import React from "react";
import "@/App.css";

const EMAIL = "customer-info@sis.com";
const BASE = process.env.PUBLIC_URL || "";
const LOGO = `${BASE}/logo.jpg`;

const ADDRESS = [
  "My Home Tycoon",
  "Unit No. 210/4",
  "House No. 6-3-1192/2/1 to 16",
  "2nd Floor, Kundan Bagh",
  "Begumpet, Hyderabad 500016",
];

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent(
    "My Home Tycoon, Unit 210/4, Kundan Bagh, Begumpet, Hyderabad 500016"
  );

function App() {
  return (
    <div className="soon">
      <div className="soon-glow" aria-hidden="true" />
      <header className="soon-bar">
        <span>Schengen Immigration Services</span>
        <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
      </header>

      <main className="soon-main">
        <img
          className="soon-logo"
          src={LOGO}
          alt="Schengen Immigration Services — Your gateway to Europe"
        />

        <p className="soon-kicker">Website launching shortly</p>
        <h1>Coming Soon</h1>
        <p className="soon-lead">
          We are preparing the full site. Visa guidance, services, and
          application details will be published here once the content is ready.
        </p>

        <div className="soon-cards">
          <a className="soon-card" href={`mailto:${EMAIL}`}>
            <span className="soon-label">Email</span>
            <span className="soon-value">{EMAIL}</span>
          </a>
          <a
            className="soon-card"
            href={MAPS_URL}
            target="_blank"
            rel="noreferrer"
          >
            <span className="soon-label">Office</span>
            <address>
              {ADDRESS.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </address>
          </a>
        </div>
      </main>

      <footer className="soon-foot">
        <span>© {new Date().getFullYear()} Schengen Immigration Services</span>
        <span>Hyderabad</span>
      </footer>
    </div>
  );
}

export default App;
